export function IconEEI() {
  return (
    <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="27" height="27" rx="4" fill="#D40078" />
      <rect x="10.1055" y="4" width="2.45214" height="18.9814" fill="white" fillOpacity="0.5" />
      <g filter="url(#filter0_d_715_3002)">
        <rect
          x="18.0781"
          y="5.07812"
          width="2.46917"
          height="19.1148"
          transform="rotate(25 18.0781 5.07812)"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_715_3002"
          x="8.75904"
          y="4.76789"
          width="12.7978"
          height="20.8491"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.93072" />
          <feGaussianBlur stdDeviation="0.62048" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_715_3002" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_715_3002"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
